import { AES, enc } from 'crypto-js';

export const encryptWithAES = (text: string, passphrase: string) => {
    return AES.encrypt(text, passphrase).toString();
};

export const decryptWithAES = (ciphertext: string, passphrase: string) => {
    const bytes = AES.decrypt(ciphertext, passphrase);
    const originalText = bytes.toString(enc.Utf8);
    return originalText;
};
